module.exports = __webpack_public_path__ + "img/thumb-songspace2@2x.1513ac7e.png";